<template>
  <div class="kutikomi-area">
    <ButtonTextLink text="口コミする" :is-red="true" @click-text="onClick" />
    <div v-show="isDialogOpen" class="background" @click="onClose"></div>
    <div v-show="isDialogOpen" class="dialog">
      <p class="title">口コミ投稿</p>
      <div class="reputation">
        評価
        <div class="stars">
          <span
            v-for="(item, index) in [1, 2, 3, 4, 5]"
            :key="index"
            :class="{ selected: item <= stars }"
            @click="onClickStar(item)"
            >★</span
          >
        </div>
      </div>
      <p class="comment">コメント</p>
      <textarea class="input-area" v-model="comment" />
      <p class="count">{{ commentCount }} / 250</p>

      <ButtonTextLink text="投稿する" @click-text="onSubmit" />
      <TextLink text="閉じる" @click-text="onClose" />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import TextLink from "@/components/Atoms/TextLink";
import Firebase from "./../../firebase";

export default {
  name: "congestion-status-dialog",
  components: {
    ButtonTextLink,
    TextLink,
  },
  props: {
    spotData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      isDialogOpen: false,
      comment: "",
      stars: 3,
    };
  },
  computed: {
    selectedSpot() {
      return spotData;
    },
    commentCount() {
      return this.comment.length;
    },
  },
  methods: {
    ...mapMutations(["setSelectedSpot", "loadingStartMini", "loadingEndMini"]),
    onClick() {
      this.isDialogOpen = true;
    },
    onClickStar(e) {
      this.stars = e;
    },
    async onSubmit() {
      this.loadingStartMini();
      await Firebase.commitReputation({
        reputation: this.stars,
        content: this.comment,
      });

      this.comment = "";
      this.isDialogOpen = false;
      this.loadingEndMini();
    },
    onClose() {
      this.isDialogOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.kutikomi-area {
  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  .dialog {
    position: fixed;
    display: flex;
    flex-direction: column;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-55%);
    background-color: white;
    z-index: 1001;
    width: 80vw;
    padding: 1rem;
    border-radius: 12px;
  }
  .title {
    font-size: 1.2rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: 1rem;
  }
  .reputation {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .stars {
      display: flex;
      flex-direction: row;
      font-size: 1.5rem;
      gap: 0.5rem;
      .selected {
        color: #ffe42e;
      }
    }
  }
  .comment {
    font-size: 0.8rem;
    margin: 0 0 0.5rem 0;
  }
  .count {
    text-align: right;
    font-size: 0.8rem;
    margin: 0 0 0.5rem 0;
  }
  .input-area {
    font-size: 1rem;
    border: none;
    border-bottom: 1px solid #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelectModal/ReviewDialog.vue